import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addWarehouse = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Warehouse',
    body
  );
  return data;
});
export const updateWarehouse = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Warehouse/${id}`,
    body
  );
  return data;
});

export const getWarehouse = catchAsync(async ({key="",value=""}) => {
  let baseUrl = '/api/resource/Warehouse?fields=["warehouse_name","phone_no","mobile_no","name","is_group","disabled","parent_warehouse","account"]&limit_start=0&limit_page_length=0'
  const filterBlusPhone = key === "phone_no" ?  value?.startsWith("+") ? value?.substring(1) : value?.startsWith("966") ? value : `966${value}` : value
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${filterBlusPhone}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteWarehouse = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Warehouse/${record}`
  );
  return data;
});
export const getWarehouseDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Warehouse/${id}`
  );
  return data;
});
